// Company branding on generated documents — client side.
// The org's setting comes from GET /api/org/document-branding (any member);
// export menus show a "Company branding" switch that starts at the org's
// default and remembers the person's choice for the rest of the session.

let _summary = null;   // { available, defaultOn, name, hasLogo, color }
let _pending = null;
let _fetchedAt = 0;
let _choice = null;    // null = follow the org default

export function getDocBranding(token, { fresh = false } = {}) {
  if (!token) return Promise.resolve(null);
  if (!fresh && _summary && Date.now() - _fetchedAt < 60_000) return Promise.resolve(_summary);
  if (_pending) return _pending;
  _pending = fetch("/api/org/document-branding", { headers: { Authorization: "Bearer " + token } })
    .then((r) => (r.ok ? r.json() : null))
    .then((d) => { _summary = d ? { available: !!d.available, defaultOn: !!d.defaultOn, name: d.name || "", hasLogo: !!d.hasLogo, color: d.color || null, logoUrl: d.logoUrl || null } : null; _fetchedAt = Date.now(); return _summary; })
    .catch(() => null)
    .finally(() => { _pending = null; });
  return _pending;
}

// After an admin saves, menus pick the new default up immediately.
export function primeDocBranding(summary) {
  _summary = summary ? { available: !!summary.available, defaultOn: !!summary.defaultOn, name: summary.name || "", hasLogo: !!summary.hasLogo, color: summary.color || null, logoUrl: summary.logoUrl || null } : null;
  _fetchedAt = Date.now();
  _choice = null;
}

export function docBrandingOn(summary) {
  if (!summary || !summary.available) return false;
  return _choice === null ? !!summary.defaultOn : _choice;
}
export function setDocBrandingChoice(on) { _choice = !!on; }

// Scale a logo to fit maxW x maxH without upscaling (keeps its shape).
export function fitLogo(w, h, maxW = 800, maxH = 300) {
  const W = Math.max(1, w | 0), H = Math.max(1, h | 0);
  const s = Math.min(1, maxW / W, maxH / H);
  return { width: Math.max(1, Math.round(W * s)), height: Math.max(1, Math.round(H * s)) };
}
